/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {CollectionFactory, Reducer} from '@modifi/redux'
import {ShareholdingCompanyView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {createSelector} from 'reselect'

const apiClient = getAuthenticatedThemisClient()

type EntityWithId = ShareholdingCompanyView & {
  externalId: NonNullable<ShareholdingCompanyView['externalId']>
}

const {reducer, selectors, actions} = CollectionFactory<
  Record<string, any>,
  EntityWithId,
  any,
  Record<string, never>
>({
  entityPrimaryKeySelector: entity => entity.externalId!,
  reducerPath: ['data', 'intermediaryShareHolders'],
  actionNamePrefix: `data/intermediary-shareholders`,
  fetchRequest: () =>
    apiClient.ShareholdingCompanies.fetch().then(
      res => res.data()?.shareholdingCompanies as EntityWithId[]
    ),
})

export default reducer as Reducer

export const selectIntermediaryShareholders = (state: Record<string, any>): EntityWithId[] =>
  selectors.selectByKeyWindow(state, 'all') as EntityWithId[]

export const selectIntermediaryShareholdersWhereLoaded = (state: Record<string, any>): boolean =>
  selectors.selectFetchCountByKeyWindow(state, 'all') > 0

export const selectIntermediaryShareholdersAreLoading = (state: Record<string, any>): boolean =>
  selectors.selectIsKeyWindowLoading(state, 'all')

export const selectIntermediaryShareholderByExternalId = (
  state: Record<string, any>,
  externalPersonId: string
): ShareholdingCompanyView | null =>
  selectors.selectById(state, externalPersonId) as ShareholdingCompanyView | null

export const selectIntermediaryShareholdingCompanyName = createSelector(
  selectIntermediaryShareholderByExternalId,
  intermediaryShareholdingCompany => intermediaryShareholdingCompany?.companyName || ''
)

export const selectCanUpdateCompany = createSelector(
  selectIntermediaryShareholderByExternalId,
  shareHoldingCompany => shareHoldingCompany?.actions?.canUpdateCompany
)

export const aFetchIntermediaryShareholders = (): any => actions!.fetch('all')
